import { AllSubKeysMessageResource } from '@/i18n/messages';
import { FuncResourceDetail } from '@/types/use';
import { LucideCustom } from '../custom-lucide/lucide-custom';
import ButtonCustom, { ButtonCustomProps } from './button';

type ButtonAuthInfo = FuncResourceDetail;

interface ButtonCustomAuthProps extends ButtonCustomProps {
    isLoading?: boolean;
    iconPlacement?: 'left' | 'right';
    showIcon?: boolean;
    iconClassName?: string;
    /**Object Function Resource  */
    auth?: ButtonAuthInfo;
    /**Translation language */
    t?: (key: any) => any;
}

const ButtonCustomAuth = ({
    auth,
    iconClassName,
    showIcon = true,
    t,
    children,
    ...rest
}: ButtonCustomAuthProps) => {
    if (!auth || !auth.isAllowed) return <></>;
    return (
        <ButtonCustom
            {...rest}
            icon={
                showIcon ? (
                    (rest.icon ?? (
                        <LucideCustom
                            iconName={auth.lucideIconName}
                            size={16}
                            className={iconClassName}
                        />
                    ))
                ) : (
                    <></>
                )
            }
        >
            {t ? t(auth.name) : auth.name}
            {children}
        </ButtonCustom>
    );
};

export default ButtonCustomAuth;
